import API from '../index';
import { Order } from '../../types/common';

interface Response {
  orders: Order[];
  meta: Meta;
}

export interface Meta {
  currentPage: number;
  lastPage: number;
  perPage: number;
}

const getOrders = async (page = 1): Promise<Response> => {
  const { meta, resources } = await API.get('/customer/transactions', { page });
  return { meta, orders: resources };
};

export default getOrders;
